<template>
  <div class="card mb-3">
    <div class="row no-gutters">
      <div class="col-sm-4">
        <a role="button" href="" @click.stop.prevent="goToDetail(layer)">
          <img :src="srcImage" alt="" class="map-preview">
        </a>
      </div>
      <div class="col-sm-8">
        <div class="card-body">
          <h5 class="card-title">
            <a role="button" href="" @click.stop.prevent="goToDetail(layer)">
              {{ title }}
            </a>
          </h5>
          <p class="card-text layer-description" v-if="description">
            {{ description }}
          </p>
          <p class="card-text" v-if="!description">{{ $t('no_descripcion') }}</p>
          <!--<p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>-->
          <span v-if="layerCode == 'falla'" class="caption mb-2 pa-2"
                style="color: #ff5722b0;background-color: #ffede7;font-size: 11px">{{
              $t('catalogo_desactivado')
            }}</span>
          <div class="download-options">

            <div v-if="layer.code == 'falla'">
              <a role="button" class="btn btn-primary btn-sm" :href="null" target="_blank">WMS</a>
              <a role="button" class="btn btn-primary btn-sm" :href="null" target="_blank">WFS</a>
              <a role="button" class="btn btn-secondary btn-sm" :href="null"
                 target="_blank">GeoJSON</a>
              <a role="button" class="btn btn-secondary btn-sm" :href="null" target="_blank">CSV</a>
              <a role="button" class="btn btn-secondary btn-sm" :href="null" target="_blank">KML</a>
              <a role="button" class="btn btn-secondary btn-sm" :href="null" target="_blank">GML</a>
              <a role="button" class="btn btn-secondary btn-sm" :href="null" target="_blank">Shapefile</a>
            </div>
            <div v-else>
              <a role="button" class="btn btn-primary btn-sm" :href="wmsLink" target="_blank">WMS</a>
              <a role="button" class="btn btn-primary btn-sm" :href="wfsLink" target="_blank">WFS</a>
              <a role="button" class="btn btn-secondary btn-sm" :href="geojsonLink"
                 target="_blank">GeoJSON</a>
              <a role="button" class="btn btn-secondary btn-sm" :href="csvLink" target="_blank">CSV</a>
              <a role="button" class="btn btn-secondary btn-sm" :href="kmlLink" target="_blank">KML</a>
              <a role="button" class="btn btn-secondary btn-sm" :href="gml3Link" target="_blank">GML</a>
              <a role="button" class="btn btn-secondary btn-sm" :href="shapefileLink" target="_blank">Shapefile</a>
            </div>
            <a role="button" class="btn btn-link btn-sm" :href="visorLink" target="_blank"><i
                class="far fa-map"></i> {{ $t('ver_en_mapa') }}</a>
          </div>
        </div>
        <div class="card-footer">
          <ul class="list-inline">
            <li><span v-tooltip="$t('campos.fecha_publicacion')"><i class="far fa-calendar-plus"></i> {{ creationDate }}</span>
            </li>
            <li><span v-tooltip="$t('campos.fecha_actualizacion')"><i class="far fa-calendar-check"></i> {{
                updateDate
              }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {AppConfig} from "../../../appConfig";
import {DateUtils} from "../../../commons/utils/dateUtils";
import {LayerLinksUtils} from "../../utils/layerLinksUtils";

export default {
  name: 'LayerItem',
  components: {},
  computed: {
    locale() {
      return this.$i18n.locale
    },
    title() {
      return this.layer[`title_${this.locale}`];
    },
    description() {
      return this.layer[`description_${this.locale}`];
    },
    creationDate() {
      return DateUtils.formatOnlyDate(this.layer['creation_date']);
    },
    updateDate() {
      return DateUtils.formatOnlyDate(this.layer['update_date']);
    },
    srcImage() {
      return `${AppConfig.APP_URL}/storage/capturas_capas/${this.layer.code}.png`;
    },
    kmlLink() {
      return LayerLinksUtils.makeKmlLink(this.layer.code);
    },
    geojsonLink() {
      return LayerLinksUtils.makeGeojsonLink(this.layer.code);
    },
    csvLink() {
      return LayerLinksUtils.makeCsvLink(this.layer.code);
    },
    gml3Link() {
      return LayerLinksUtils.makeGml3Link(this.layer.code);
    },
    shapefileLink() {
      return LayerLinksUtils.makeShapefileLink(this.layer.code);
    },
    wmsLink() {
      return LayerLinksUtils.makeWmsLink(this.layer.code);
    },
    wfsLink() {
      return LayerLinksUtils.makeWfsLink(this.layer.code);
    },
    visorLink() {
      return `${AppConfig.APP_URL}/${this.locale}/visor#/?layers=${this.layer.code}`;
    }
  },
  props: {
    layer: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    foo: 'dfd'
  }),
  methods: {
    goToDetail(layer) {

      this.$router.push({name: 'layer-detail', params: {layerCode: layer.code}});
    }
  }
}
</script>

<style lang="scss">
.map-preview {
  height: 100%;
  width: 100%;
  display: block;
  object-fit: cover;
}

.download-options {
  margin-bottom: 10px;

  a {
    margin-bottom: 5px;
  }
}

$descriptionlineHeigth: 1.5rem;

.layer-description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-height: $descriptionlineHeigth; /* fallback */
  max-height: calc(#{$descriptionlineHeigth} * 2); /* fallback */

}

ul.list-inline {
  margin-bottom: 0;
  font-size: 0.9rem;

  li {
    display: inline-block;
    margin: 0 5px;

    i {
      margin: 0 5px;
    }
  }
}
</style>